module.exports = __webpack_public_path__ + "assets/img/barrel.554a59f9.png";